import { BCard } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBCard when migrating. */
export const EgBCard = createEgBootstrapProxy("EgBCard", BCard);
